import React from 'react';
export function DeviceIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-135">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" data-id="element-136" />
      <line x1="12" y1="18" x2="12.01" y2="18" data-id="element-137" />
    </svg>;
}